import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";

//const list = ['TU SELECCIÓN', 'TUS DATOS', 'RESUMEN Y PAGO', 'CONFIRMACIÓN RESERVA']
const list = ['yourselection', 'yourdata', 'summary', 'confirmation']

const Item = ({index, item, select}) => {
  const cname = (!select)?'step': 'step step-select'
  return(
    <li>
      <div className={cname}>
        {index + 1} - {item}
      </div>
    </li>
  )
}

class headerNav extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].headernav

    const {step} = this.props
    return (
      <nav className='header-nav'>

        <ul>
          {list.map((item, index) => <Item key={index} index={index} item={langPlace[item]} select={step === index}/>)}
        </ul>

      </nav>
    )
  }
}

export default connect(
	(state) => ({settings: state.settings})
)(headerNav)



// WEBPACK FOOTER //
// ./src/shared/routes/components/headerNav.js